import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Droplets, Wind } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function WeatherWidget() {
  const { t } = useTranslation();
  const [data, setData] = useState(null);

  useEffect(() => {
    async function load() {
      try {
        const r = await fetch(`${API}/public/weather?city=cakovec`);
        const d = await r.json();
        if (!d?.error) setData(d);
      } catch {}
    }
    load();
    const iv = setInterval(load, 30 * 60 * 1000);
    return () => clearInterval(iv);
  }, []);

  if (!data) return null;

  return (
    <Link to="/vrijeme" className="block bg-gradient-to-br from-sky-50 to-sky-100 dark:from-[#111827] dark:to-[#0f172a] border border-sky-100 dark:border-gray-800 rounded-xl p-5 hover:shadow-md transition-shadow" data-testid="weather-widget">
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-[11px] font-bold uppercase tracking-widest text-sky-700 dark:text-sky-400">{t('widgets.weather_label')} · {data.city}</h3>
      </div>
      <div className="flex items-center gap-3">
        <div className="text-5xl leading-none">{data.current.emoji}</div>
        <div>
          <p className="text-3xl font-bold text-gray-900 dark:text-gray-100">{data.current.temp_c}°C</p>
          <p className="text-[11px] text-gray-600 dark:text-gray-300">{data.current.condition_label_hr}</p>
        </div>
      </div>
      <div className="flex gap-3 text-[10px] text-gray-500 dark:text-gray-400 mt-3">
        <span className="flex items-center gap-1"><Droplets size={10} /> {data.current.humidity}%</span>
        <span className="flex items-center gap-1"><Wind size={10} /> {data.current.wind_kmh} km/h</span>
      </div>
    </Link>
  );
}
